import React, { useState } from "react";
import { IconButton, Dialog, DialogContent, DialogTitle } from "@mui/material";
import { CloseRounded, DeleteOutline } from "@mui/icons-material";
import styles from "./styles";
import { isEmpty } from "lodash";
import { formattedAmountWithoutAed } from "../../../../../utils/CommonFunction";
import { getApiData, postFormData } from "../../../../../utils/APIHelper";
import { Setting } from "../../../../../utils/Setting";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { ReactComponent as SmallDhiramIcon } from "../../../../../assets/svg/SmallDhiramIcon.svg";
import { renderCurrencyIcon } from "../../../../../utils/CurrencyUtils";

function BudgetItemModal({
  selectedBudget,
  setSelectedBudget,
  getDetailsApiCall,
}) {
  const { id } = useParams();
  const [buttonLoader, setButtonLoader] = useState(false);
  const [hovered, setHovered] = useState(false);

  const handleCloseModal = () => {
    setSelectedBudget(null);
  };

  const handleImageChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("file_1", file);
      formData.append("type", "budgetItemDetails");
      formData.append("project_id", selectedBudget?.id);

      try {
        const response = await postFormData(
          Setting.endpoints.projectFiles,
          formData
        );
        if (response.success) {
          toast.success("File uploaded successfully");
          await getDetailsApiCall(id);
        } else {
          toast.error("File upload failed");
        }
      } catch (error) {
        toast.error("An error occurred during file upload");
      }
    }
  };

  const handleDeleteImage = async () => {
    setButtonLoader(true);
    try {
      const imageId = selectedBudget?.buget_image?.[0]?.id;
      if (!imageId) {
        toast.error("No image to delete.");
        return;
      }

      const response = await getApiData(
        `api/project/delete-files/${imageId}`,
        "POST",
        {},
        { "Content-Type": "application/json" },
        false
      );

      if (response.success) {
        toast.success(response.message);
        await getDetailsApiCall(id);
      }
    } catch (error) {
      toast.error(error.toString());
    } finally {
      setButtonLoader(false);
    }
  };

  return (
    <>
      <Dialog
        open={!!selectedBudget}
        onClose={handleCloseModal}
        maxWidth="sm"
        fullWidth
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "12px",
          },
        }}
      >
        {selectedBudget && (
          <>
            <DialogTitle
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "0",
                position: "relative",
              }}
            >
              {!isEmpty(selectedBudget?.buget_image) ? (
                <div
                  style={{ position: "relative", width: "100%" }}
                  onMouseEnter={() => setHovered(true)}
                  onMouseLeave={() => setHovered(false)}
                >
                  <img
                    src={selectedBudget?.buget_image[0]?.image}
                    alt="Budget Image"
                    style={{
                      width: "100%",
                      height: "250px",
                      objectFit: "cover",
                      border: "none",
                      borderRadius: "8px",
                      borderBottomLeftRadius: 0,
                      borderBottomRightRadius: 0,
                      boxShadow: "none",
                    }}
                  />
                  {hovered && (
                    <div
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        background: "rgba(0, 0, 0, 0.6)",
                        padding: "10px",
                        borderRadius: "50%",
                      }}
                    >
                      <IconButton
                        onClick={handleDeleteImage}
                        style={{
                          color: "white",
                          backgroundColor: "red",
                          borderRadius: "50%",
                        }}
                      >
                        <DeleteOutline style={{ fontSize: "18px" }} />
                      </IconButton>
                    </div>
                  )}
                </div>
              ) : (
                <IconButton
                  component="label"
                  style={{
                    width: "100%",
                    height: "250px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "8px",
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0,
                    border: "1px dashed #ccc",
                    margin: "0",
                    cursor: "pointer",
                    background: "#fafafa",
                  }}
                >
                  <AddIcon fontSize="small" />
                  <input
                    type="file"
                    hidden
                    onChange={(e) => handleImageChange(e)}
                    accept="image/*"
                  />
                </IconButton>
              )}
              <IconButton
                onClick={handleCloseModal}
                style={{ position: "absolute", top: 5, right: 5 }}
              >
                <CloseRounded />
              </IconButton>
            </DialogTitle>
            <DialogContent
              style={{
                ...styles.columnFlex,
                ...styles.container,
                gap: "25px",
                padding: "4vh 2vw",
              }}
            >
              <div style={{ ...styles.columnFlex }}>
                <h2 style={styles.modal_heading}>{selectedBudget?.name}</h2>
                <p style={styles.modal_desc}>{selectedBudget?.specification}</p>
              </div>
              <div style={{ ...styles.columnFlex, gap: "15px" }}>
                <div style={styles.section_heading}>Specs</div>
                <div style={{ ...styles.columnFlex, gap: "15px" }}>
                  <div
                    style={{
                      ...styles.rowFlex,
                      justifyContent: "space-between",
                    }}
                  >
                    <p style={styles.modal_desc}>Material Type</p>
                    <p style={styles.modal_value}>
                      {selectedBudget?.material_type || "-"}
                    </p>
                  </div>

                  <div
                    style={{
                      ...styles.rowFlex,
                      justifyContent: "space-between",
                    }}
                  >
                    <p style={styles.modal_desc}>Material Unit</p>
                    <p style={styles.modal_value}>
                      {selectedBudget?.material_unit || "-"}
                    </p>
                  </div>
                </div>
              </div>{" "}
              <div style={{ ...styles.columnFlex, gap: "15px" }}>
                <div style={styles.section_heading}>Quantity</div>
                <div style={{ ...styles.columnFlex, gap: "15px" }}>
                  <div
                    style={{
                      ...styles.rowFlex,
                      justifyContent: "space-between",
                    }}
                  >
                    <p style={styles.modal_desc}>Unit Cost</p>
                    <p style={styles.modal_value}>
                      {selectedBudget?.material_unit_price ? (
                        <span
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          {renderCurrencyIcon('small')}
                          {formattedAmountWithoutAed(
                            selectedBudget?.material_unit_price
                          )}
                        </span>
                      ) : (
                        "-"
                      )}
                    </p>
                  </div>
                  <div
                    style={{
                      ...styles.rowFlex,
                      justifyContent: "space-between",
                    }}
                  >
                    <p style={styles.modal_desc}>Quantity</p>
                    <p style={styles.modal_value}>
                      {selectedBudget?.qty || "-"}
                    </p>
                  </div>

                  <div
                    style={{
                      ...styles.rowFlex,
                      justifyContent: "space-between",
                    }}
                  >
                    <p style={styles.modal_desc}>Manpower Rate</p>
                    <p style={styles.modal_value}>
                      {selectedBudget?.manpower_rate || "-"}
                    </p>
                  </div>
                  <div
                    style={{
                      ...styles.rowFlex,
                      justifyContent: "space-between",
                    }}
                  >
                    <p style={styles.modal_desc}>Days</p>
                    <p style={styles.modal_value}>
                      {selectedBudget?.days || "-"}
                    </p>
                  </div>
                </div>
              </div>
            </DialogContent>
          </>
        )}
      </Dialog>
    </>
  );
}

export default BudgetItemModal;
